export default "__VITE_ASSET__e335c431__"